<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Recipes</h1>
      <div class="text-large">Because no good story ever started with "so I was eating a salad...".</div>
    </div>
  </div>
<Posts Category="recipes" ShowTitle="true"/>


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
